import { TFunction } from 'i18next'

import { Organization } from '@modules-deprecated/app/organization/types/organization'

import { OnboardingAccountingManagement } from '../../../../../enums/onboardingAccountingManagement'
import { SingleCardSelectOption } from '../../SingleCardSelect'

export const getAccountingManagementOptions = (t: TFunction, organization?: Organization): SingleCardSelectOption[] => {
  const isFrenchOrganization = organization?.countryId === 'FR'

  return [
    {
      id: OnboardingAccountingManagement.Myself,
      label: t('onboarding.steps.accounting_management.myself'),
    },
    {
      id: OnboardingAccountingManagement.SplitWorkWithAdvisor,
      label: t('onboarding.steps.accounting_management.mixed'),
    },
    {
      id: OnboardingAccountingManagement.Advisor,
      label: t('onboarding.steps.accounting_management.accountant'),
    },
    ...(isFrenchOrganization
      ? []
      : [
          {
            id: OnboardingAccountingManagement.AccountingFirm,
            label: t('onboarding.steps.accounting_management.outsourced'),
          },
        ]),
  ]
}
